<template>
  <div>
    <div class="content-body">
      <div class="row">
        
        <div class="col-xl-4 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <img :src="$store.getters.getProfilePhoto" class="card-img-top img-fluid"/>
              
              <div class="card-block">
                <h4 class="card-title">{{user.name}}</h4>

                <center>
                  <input type="file" name="file" id="file" class="inputfile" accept="image/*" @change="onUploadImg"/>
                  <label id="file_loader" for="file">
                    <a class="btn btn-warning btn-min-width" role="button"><i class="icon-upload3"></i> {{$t('profile.buttons.photo')}}</a>
                  </label>
                </center>
                <!--<p class="card-text">Some quick example text to build on the card content.</p>-->
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-block">
                <form class="form">
                  <div class="form-body">
                    <h4 class="form-section"><i class="icon-eye6"></i> {{$t('profile.titles.aboutUsr')}}</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="login">{{$t('users.table.login')}}</label>
                          <input type="text" id="login" class="form-control border-primary" v-model="user.login" name="login">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="name">{{$t('users.table.name')}}</label>
                          <input type="text" id="name" class="form-control border-primary" v-model="user.name" name="name">
                        </div>
                      </div>
                      
                      <div v-if="changePass">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="pass1">{{$t('profile.table.oldPass')}}</label>
                          <input type="password" id="pass1" class="form-control border-primary" v-model="user.password" name="pass1">
                        </div>
                      </div>
                      <div class="col-md-6 form-group">
                        <label for="pass2">{{$t('profile.table.newPass')}}</label>
                        <input type="password" id="passNew" class="form-control border-primary" v-model="user.newPassword" name="passNew">
                      </div>
                      <div class="form-group offset-md-3 col-md-6">
                        <label for="passNew">{{$t('profile.table.newPass2')}}</label>
                        <input type="password" id="pass2" class="form-control border-primary" v-model="user.newPassword2" name="pass2">
                      </div>
                      </div>
                      
                      <div class="col-md-12">
                          <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 5px;">
                              <div class="btn-group">
                                <button v-if="!changePass" type="button" class=" w-100 btn btn-warning" @click="changePass = true">
                                  <i class="icon-pencil22"></i> {{$t('profile.buttons.chnPass')}}
                                </button>
                                <button v-if="changePass" @click="changePassword()" type="button" class="btn btn-success">
                                  <i class="icon-check2"></i> {{$t('profile.buttons.save')}}
                                </button>
                                <button v-if="changePass" @click="changePass = false" type="button" class="btn btn-warning">
                                  <i class="icon-cross"></i> {{$t('equipm.buttons.cancel')}}
                                </button>
                              </div>
                          </div>
                      </div>

                    </div>

                    <h4 class="form-section"><i class="icon-mail6"></i> {{$t('profile.titles.contact')}}</h4>

                    <div class="form-group">
                      <label for="email">{{$t('users.table.email')}}</label>
                      <input class="form-control border-primary" v-model="user.email" type="email" placeholder="email" id="email">
                    </div>

                    <div class="form-group">
                      <label for="city">{{ $t('profile.table.city')}}</label>
                      <input class="form-control border-primary" v-model="user.frontOffice" type="text" id="city" name="city">
                    </div>

                    <div class="form-group">
                      <label for="nameCl">{{$t('users.table.nameClient')}}</label>
                      <input class="form-control border-primary" type="text" v-model="user.organization" id="nameCl" name="nameCl" disabled>
                    </div>

                    <div class="form-group">
                      <label for="telephone">{{$t('users.table.phone')}}</label>
                      <input class="form-control border-primary" type="text" v-model="user.tel" id="telephone" name="telephone">
                    </div>

                    <!--<div class="form-group">
                      <label for="userinput8">Some extra info</label>
                      <textarea id="userinput8" rows="5" class="form-control border-primary" name="bio" placeholder="Bio"></textarea>
                    </div>-->

                  </div>

                  <div class="form-actions center">
                    <!--<button type="button" class="btn btn-warning mr-1">
                      <i class="icon-cross2"></i> Cancel
                    </button>-->
                    <button type="button" class="btn btn-primary" @click="saveProfile">
                      <i class="icon-check2"></i> {{$t('profile.buttons.save')}}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Profile",
    components: {},
    data() {
      return {
        changePass: false,
        user:{
          login: null,
          name: null,
          email: null,
          tel: null,
          organization: null,
          frontOffice: null,
          photo: null,
          password: null,
          newPassword2: null,
          newPassword: null,
        },
      }
    },
    mounted() {
      this.checkAuthorized().then(result => {
        this.getDataProfile();
      })
      .catch(err => {
        this.showNotification('custom-error',this.$t('errors.title'),this.$t('errors.500'));
      });
    },
    methods: {
      getDataProfile() {
        this.makeQuery("/drawing/getDataProfile", { session: this.$store.getters.getUserToken})
        .then(result => {
            if(result != null){
              this.user.login = result.data.login;
              this.user.name = result.data.name;
              this.user.email = result.data.email;
              this.user.tel = result.data.tel;
              this.user.organization = result.data.organization;
              this.user.frontOffice  = result.data.frontOffice;

              //this.$store.state.profilePhoto = "data:image/jpg;base64," + result.image;
            }
        })
        .catch(result => {this.showNotification('custom-error','Error',result); });

      },
      saveProfile(){
        if(this.changePass &&
          ((this.user.password != this.user.newPassword2) 
            || ((this.user.newPassword2.length > 1) && (this.user.newPassword == ''))
          )
        ){
          this.showNotification('custom-error','Error',this.$t('errors.passComp'));
          return
        }
        this.makeQuery("/drawing/saveProfile", {
          session: this.$store.getters.getUserToken,
          user: {
            login: this.user.login,
            name: this.user.name,
            email: this.user.email,
            tel: this.user.tel,
            organization: this.user.organization,
            frontOffice: this.user.frontOffice,
            photo: this.user.photo,
          },
        })
        .then(res => {
            if(res != null){
              this.changePass = false;
                this.showNotification('custom-success','Profile',"Changes saved.");
            }
        })
        .catch(result => {this.showNotification('custom-error','Error',result); });
      },
      changePassword(){
        this.user.password = this.user.password.trim();
        this.user.newPassword = this.user.newPassword.trim();
        this.user.newPassword2 = this.user.newPassword2.trim();


        if(this.user.newPassword2 != this.user.newPassword){
          this.showNotification('custom-error','Error',this.$t('errors.passComp'));
          return
        }
        if(this.user.newPassword.length < 6){
          this.showNotification('custom-error','Error',this.$t('errors.passLeng'));
          return
        }
        if(this.user.password.length < 1){
          this.showNotification('custom-error','Error',this.$t('errors.passFill'));
          return
        }
        this.makeQuery("/service/changePasswordService", {
          token: this.$store.getters.getUserToken,
          dataRequest: { oldPassword: this.user.password, newPassword: this.user.newPassword}
        })
        .then(res => {
            if(res != null){
              this.changePass = false;
                this.showNotification('custom-success','Profile',"Changes saved.");
                this.user.newPassword2 = null;
                this.user.newPassword = null;
                this.user.password = null;
            }
        })
        .catch(result => {this.showNotification('custom-error','Error',result); });


      },
      onUploadImg(e){        
        let tt = null;
        let _this = this;
        if (e.target.files.length > 0){
            for (let i = 0; i < e.target.files.length; i++) {
                const element = e.target.files[i];
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = e => {

                  var img = new Image;
                  img.onload = function() {
                    if(img.width > 1500){
                      //зжимання
                      var w = img.width;
                      var h = img.height;
                      var canvas = document.createElement('canvas');
                      var ctx = canvas.getContext('2d'); // Создаем узел атрибута
                      var anw = document.createAttribute("width"); 
                      anw.nodeValue = w;
                      var anh = document.createAttribute("height");
                      anh.nodeValue = h;
                      canvas.setAttributeNode(anw);
                      canvas.setAttributeNode(anh);
                      ctx.drawImage(img, 0, 0, w, h);
                      // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                      var base64Img = canvas.toDataURL('image/jpeg',.6);
                      //зжимання

                      tt = (base64Img).split(',');
                    } else {
                      tt = (img.src).split(',');
                    }

                    _this.user.photo = { name: 'logo_' + _this.user.login, data: tt[1] };
                    localStorage.setItem('profileImg', tt[0] + ',' + tt[1]);
                    _this.$store.commit('setProfilePhoto',tt[0] + ',' + tt[1]);
                  }
                  img.src = e.target.result;
                };                        
            }
        }





      },

    }

  }
</script>

<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
</style> 



// WEBPACK FOOTER //
// src/pages/Profile.vue